module.exports = __webpack_public_path__ + "static/media/logo_esn_fr.7e38f2fa.svg";